"use client";

import { Box, Container, FormControl, IconButton, InputAdornment, OutlinedInput, Typography } from "@mui/material";
import color from "@/style/theme/Color";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import { useRouter } from "next/navigation";

export function IndexHeader() {
  const [keyword, setKeyword] = useState('');
  const router = useRouter();

  const handleEnterSubmit = (event: any) => {
    if (event.code === "Enter") {
      router.push("/koleksi?q=" + keyword);
    }
  };

  const handleClickSubmit = () => {
    router.push("/koleksi?q=" + keyword);
  };

  const handleChange = (event: any) => {
    setKeyword(event.target.value);
  };

  return (
    <Box
      sx={{
        paddingY: "6rem",
        minHeight: "100vh",
        background: `linear-gradient(to right, rgba(2, 62, 138, 0.9), rgba(0, 180, 216, 0.7)), url(/image/homepage_background.webp)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center"
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            width: "100%",
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Box sx={{ width: "100%", maxWidth: "900px", margin: "auto" }}>
            <Typography
              component="h1"
              sx={{
                textAlign: "center",
                fontSize: { xs: "2.5rem", md: "4rem" },
                fontWeight: 800,
                color: color.white,
                lineHeight: 1.2,
                textShadow: "0px 4px 20px rgba(0,0,0,0.3)",
                letterSpacing: "-0.02em"
              }}
            >
              Berbagai Kebutuhan Perpustakaan STIS dalam Satu Akses
            </Typography>

            <Typography
              sx={{
                marginTop: "24px",
                textAlign: "center",
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: { xs: "1rem", md: "1.125rem" },
                maxWidth: "700px",
                marginX: "auto",
                textShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                lineHeight: 1.6
              }}
            >
              Dapatkan akses mudah ke layanan perpustakaan dan berbagai
              informasi seputar Perpustakaan STIS, serta berikan
              masukkan agar kami dapat memberikan layanan yang lebih baik.
            </Typography>
          </Box>

          <Box
            sx={{
              padding: { xs: "1.5rem", sm: "2rem" },
              marginTop: "3rem",
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(16px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: "20px",
              width: { xs: "100%", sm: "40rem" },
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Typography sx={{ color: color.white, fontWeight: 500, mb: 1, textShadow: "0px 1px 2px rgba(0,0,0,0.1)" }}>
              Telusuri koleksi kami
            </Typography>
            <FormControl sx={{ width: "100%" }}>
              <OutlinedInput
                placeholder="Cari judul buku, pengarang, atau kata kunci..."
                size="medium"
                autoFocus={true}
                value={keyword}
                onKeyUp={handleEnterSubmit}
                onChange={handleChange}
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  borderRadius: "12px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0 0 0 4px rgba(255, 255, 255, 0.2)"
                  },
                  "&.Mui-focused": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0 0 0 4px rgba(255, 255, 255, 0.3)",
                    border: 'none'
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none"
                  }
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={handleClickSubmit} 
                      sx={{ 
                        backgroundColor: color.blue, 
                        color: color.white,
                        borderRadius: "8px",
                        "&:hover": { backgroundColor: "#0096B4" }
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}